import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Button } from '@mantine/core';
import { DownloadSimple, FileXls, FilePdf } from '@phosphor-icons/react';
import { apiUrl } from '../utils/api';

function downloadFile(url, filename) {
  const token = localStorage.getItem('token');
  return fetch(apiUrl(url), {
    headers: { Authorization: `Token ${token}` },
  })
    .then(res => res.blob())
    .then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filename;
      a.click();
      URL.revokeObjectURL(a.href);
    });
}

export default function ExportMenu({ baseUrl, filename, filters = '' }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleExport = (format) => {
    setLoading(true);
    const sep = baseUrl.includes('?') ? '&' : '?';
    const url = `${baseUrl}${filters ? sep + filters + '&' : sep}export_format=${format}`;
    const ext = format === 'pdf' ? '.pdf' : '.xlsx';
    downloadFile(url, `${filename}${ext}`).finally(() => setLoading(false));
  };

  return (
    <Menu shadow="md" width={160} position="bottom-end">
      <Menu.Target>
        <Button variant="default" size="sm" leftSection={<DownloadSimple size={14} />} loading={loading}>
          {t('shell.export.button')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item leftSection={<FileXls size={16} weight="duotone" color="var(--mantine-color-green-6)" />} onClick={() => handleExport('xlsx')}>
          {t('shell.export.excel')}
        </Menu.Item>
        <Menu.Item leftSection={<FilePdf size={16} weight="duotone" color="var(--mantine-color-red-6)" />} onClick={() => handleExport('pdf')}>
          {t('shell.export.pdf')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
